export const UTM_SOURCES = [
	{ value: 'all', label: 'All' },
	{ value: 'google-network', label: 'Google Network' },
	{ value: 'fb', label: 'Facebook' },
	{ value: 'platform', label: 'Platform' },
];
